// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
import { ContractStatesEnumeration } from 'containers/contract/enumerations/contract-states.enumeration';
// Types
import { AppContextType } from 'contexts/types/app.contexts.type';

const isContractual = (currentState: AppContextType['currentState']): boolean =>
  currentState === AppStatesEnumeration.CHECKOUT_SIGNING_CONTRACTUAL;

const isOtp = (currentState: AppContextType['currentState']): boolean =>
  currentState === AppStatesEnumeration.CHECKOUT_SIGNING_OTP;

const isPreContractual = (currentState: AppContextType['currentState']): boolean =>
  currentState === AppStatesEnumeration.CHECKOUT_SIGNING;

const getContractStateFromCurrentState = (
  currentState: AppContextType['currentState']
): ContractStatesEnumeration => {
  let contractState;
  switch (true) {
    case isContractual(currentState):
      contractState = ContractStatesEnumeration.CONTRACTUAL;
      break;
    case isOtp(currentState):
      contractState = ContractStatesEnumeration.OTP;
      break;
    case isPreContractual(currentState):
    default:
      contractState = ContractStatesEnumeration.PRECONTRACTUAL;
      break;
  }
  return contractState;
};

export { getContractStateFromCurrentState, isContractual, isOtp, isPreContractual };
